import React from 'react';

import IssueFloatingButton from './IssueFloatingButton';
import ReportIssueForm from './ReportIssueForm';
import Popup from '../Popup';

export const ReportIssueContainer = (props) => (
    <Popup
        header={'Report an Issue'}
        overlay={<ReportIssueForm {...props} />}
        zIndex={50}
        usePortal
    >
        <IssueFloatingButton />
    </Popup>
);
